import { Tooltip } from "primereact/tooltip";
import SlidersIcon from "../../../ui/assets/icons/sliders-h.svg";
import ArrowUpRightIcon from "../../icons/ArrowUpRightIcon";

import { dayJsFormat } from "../../../ui/shared/global-tools/dayjs.helpers";
import "./StatsCard.scss";

export default function StatsCard({
  label,
  total,
  percentage,
  date,
  id,
}: {
  label?: string;
  total: number;
  percentage?: {
    value: number;
    increase: boolean;
  };
  date?: string;
  id: string;
}) {
  return (
    <div className="StatsCard">
      <img className="StatsCard-iconOntop" src={SlidersIcon} alt="" />

      <div className="StatsCard-body">
        {label && (
          <>
            {label.length > 14 && <Tooltip target={`.Tooltip-${id}`} position="top" />}{" "}
            <span className={`StatsCard-label ${`Tooltip-${id}`}`} data-pr-tooltip={label}>
              {label}
            </span>{" "}
          </>
        )}
        <span className="StatsCard-total">{total}</span>
        {percentage && (
          <small className="StatsCard-sinceLastYear">
            Depuis l'année dernière{" "}
            <b className={`StatsCard-percentage ${percentage.increase ? "success" : "danger"}`}>
              {percentage.value}%
              <ArrowUpRightIcon />
            </b>
          </small>
        )}
      </div>

      {date && (
        <div className="StatsCard-footer">
          <span className="StatsCard-date">{dayJsFormat(date, "DD-MM-YYYY")}</span>
          <small className="StatsCard-lastUpdate">Dernière mise à jour</small>
        </div>
      )}
    </div>
  );
}
